export default "__VITE_ASSET__0cf04ccc__"